// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_upper__VkmmB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Settings_upper__VkmmB {
    margin-top: 4rem;
    flex-direction: column;
  }
}
.Settings_upper__title__k8wwl {
  width: 38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Settings_upper__title_shape__X3-hw {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--default-font-h2);
  font-weight: 700;
  background-color: var(--color-fash-primary-4);
  width: 9rem;
  height: 9rem;
  border-radius: 9rem;
  margin-bottom: 2rem;
}

@media only screen and (max-width: 37.5em) {
  .Settings_main__nav__7J4Il {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Settings_main__nav__7J4Il > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_main__nav_item__XO2S4 {
  width: 38rem;
  border: 1px solid var(--color-fash-primary-3);
  border-radius: 1rem;
  padding: 1.9rem 1rem;
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_main__nav_item__XO2S4:hover {
  border: 2px solid var(--color-fash-primary-3);
  color: var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-fash-primary-4);
}
.Settings_main__nav_item__icon__Qs5-6 {
  font-size: 2.5rem;
  transition: all 0.2s;
}
.Settings_main__nav_item__icon2__mFi3W {
  font-size: 2.5rem;
  transform: rotateZ(90deg);
  transition: all 0.2s;
}

@media only screen and (max-width: 37.5em) {
  .Settings_sub__nav__HWTrS {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Settings_sub__nav__HWTrS > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_sub__nav_item__OCNaP {
  width: 36rem;
  border: 1px solid var(--color-dark);
  border-radius: 1rem;
  padding: 1.9rem 1rem;
  display: grid;
  grid-template-columns: 1fr 8fr 1fr;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 2rem;
}
.Settings_sub__nav_item__OCNaP:hover {
  border: 2px solid var(--color-dark);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-light-gry);
  font-weight: 700;
}
.Settings_sub__nav_item__icon__aS4MS {
  font-size: 2.5rem;
}

.Settings_bus__FfqYA {
  margin-top: 1rem;
  width: 40rem;
}
.Settings_bus__head__\\+iwa1 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 2rem;
}
.Settings_bus__head__\\+iwa1 > :not(:last-child) {
  margin-right: 2rem;
}
.Settings_bus__edit__u-pM8 {
  display: flex;
  flex-direction: column;
  font-size: 2.5rem;
  align-items: center;
  cursor: pointer;
}
.Settings_bus__edit__u-pM8 > :not(:last-child) {
  margin-bottom: 1rem;
}
.Settings_bus__edit__u-pM8:hover {
  color: var(--color-fash-primary-3);
}
.Settings_bus__details__UXQRr > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_bus__img__H3nvL {
  display: flex;
  justify-content: center;
}
.Settings_bus__logo__cbPcH {
  height: 7rem;
}

.Settings_sec__img__UBa8n {
  width: 25rem;
  margin-bottom: 3rem;
}
.Settings_sec__img_contain__pg1nC {
  display: flex;
  justify-content: center;
}
.Settings_sec__center__TahHv {
  width: 40rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Settings_am__img__1DqEQ {
  height: 10rem;
  border-radius: 10rem;
}
.Settings_am__img_contain__-SJHU {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12rem;
  height: 12rem;
  border-radius: 12rem;
  background-color: var(--color-primary-7);
}
.Settings_am__btn__9MQlO {
  display: flex;
  gap: 2rem;
}

.Settings_if__img__3br2T {
  height: 22rem;
}
.Settings_if__share__BsmS- {
  display: flex;
  font-size: var(--default-font-small);
}
.Settings_if__share_1__obhQz {
  background-color: var(--color-dark);
  width: 28rem;
  padding: 1.5rem 2rem;
  border-radius: 2rem 0 0 2rem;
  word-wrap: break-word;
  color: var(--color-white);
}
.Settings_if__share_1__obhQz span {
  color: var(--color-primary-3);
}
.Settings_if__share_2__zcvCB {
  background-color: var(--color-dark-3);
  color: var(--color-white);
  width: 10rem;
  padding: 1.5rem 2rem;
  border-radius: 0 2rem 2rem 0;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}
.Settings_if__share_2__zcvCB:hover {
  background-color: var(--color-fash-primary-3);
}

.Settings_logout__U3JnU {
  display: flex;
  gap: 2rem;
}

.Settings_cs__gIIaj {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Settings_cs__img__r1mT5 {
  height: 23rem;
}
.Settings_cs__menu__RE8EV {
  margin-top: 3rem;
}
.Settings_cs__menu__RE8EV > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_cs__menu_main__3YUqa {
  display: flex;
  padding: 2.5rem 2rem;
  justify-content: space-between;
  align-items: center;
  font-size: 3rem;
  width: 42rem;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_cs__menu_main__3YUqa:hover {
  filter: brightness(1.05);
  border: 1px solid var(--color-primary);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);
}
.Settings_cs__menu_main__faq__nSrYx {
  background-color: var(--color-primary-3);
}
.Settings_cs__menu_main__send__OP8TA {
  background-color: var(--color-primary-7);
}
.Settings_cs__menu_main__speak__a8FDJ {
  background-color: var(--color-primary-8);
}
.Settings_cs__dials__mCgL- {
  display: flex;
  gap: 2rem;
  align-items: center;
  font-size: 3rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.Settings_cs__socials__eF8CK {
  display: flex;
  font-size: 3rem;
  justify-content: center;
  color: var(--color-primary);
}
.Settings_cs__socials__eF8CK > :not(:last-child) {
  margin-right: 2rem;
}
.Settings_cs__socials__eF8CK > * {
  cursor: pointer;
}
.Settings_cs__socials__eF8CK > *:hover {
  color: var(--color-primary-4);
}

.Settings_faq__eYSCI {
  width: 42rem;
}
.Settings_faq__line__acoxP {
  border-top: 1px solid var(--color-primary);
  margin: 1rem 0;
}

.Settings_pin__4qjSC {
  width: 38rem;
}
.Settings_pin__4qjSC > :nth-child(3) {
  margin-left: 4rem;
}

.Settings_iconfig__CVqHf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Settings_iconfig__menu__JlARv {
  margin-top: 3rem;
  transition: all 2s;
}
.Settings_iconfig__menu__JlARv > :not(:last-child) {
  margin-bottom: 2rem;
}
.Settings_iconfig__menu_main__F5odO {
  display: flex;
  padding: 2.5rem 2rem;
  justify-content: space-between;
  align-items: center;
  font-size: 3rem;
  width: 42rem;
  background-color: var(--color-primary-7);
  border-radius: 1.5rem;
  transition: all 0.2s;
  cursor: pointer;
}
.Settings_iconfig__menu_main__F5odO:hover {
  filter: brightness(1.05);
  border: 1px solid var(--color-primary);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);
}
.Settings_iconfig__settings__knJP- {
  padding: 2rem 1.8rem;
  animation: Settings_translateDown__EEHVR 0.5s;
}
.Settings_iconfig__settings_feature__fi1QQ {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}
.Settings_iconfig__settings_feature__fi1QQ:not(:last-child) {
  margin: 2rem 0;
}
.Settings_iconfig__settings_feature_text__YiTrx {
  width: 80%;
  align-self: center;
}
.Settings_iconfig__beside__Rov1s {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}

.Settings_error__B\\+Z6D {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
  width: 38rem;
}

@keyframes Settings_translateDown__EEHVR {
  0% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.Settings_kyc__list__OkdXD {
  display: flex;
  align-items: center;
  width: 38rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-grey);
  margin-bottom: 2rem;
}
.Settings_kyc__list__icon__7d40V {
  font-size: 4rem;
  color: var(--color-green);
  background-color: var(--color-green-3);
  border-radius: 5rem;
  padding: 0.5rem;
  box-sizing: border-box;
  margin-right: 1rem;
}
.Settings_kyc__list__OkdXD span {
  width: 33rem;
  word-wrap: break-word;
}

.Settings_bicContainer__Jo9Bc {
  display: flex;
  justify-content: center;
  max-width: 36rem;
}
.Settings_bicContainer__bic__EYiXy {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 36rem;
}

.Settings_configDetails__f4LiO {
  display: grid;
  grid-template-columns: 55% 35%;
  max-width: 40rem;
  justify-content: center;
  justify-self: center;
  margin-bottom: 2rem;
  gap: 2rem;
  padding: 0 1rem;
}
.Settings_configDetails_btn__w9tUy {
  display: flex;
  justify-content: center;
  width: 100%;
}

.Settings_repeat__0X8Xw {
  display: flex;
  justify-content: space-between;
  width: 38rem;
}

.Settings_cards__FXfy5 {
  display: flex;
  width: 38rem;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-grey);
  justify-content: space-between;
}
.Settings_cards__FXfy5 img {
  height: 3rem;
  margin-right: 3rem;
}
.Settings_cards__beside__2Z3Xb {
  display: flex;
  align-items: center;
}
.Settings_cards__delete__k1TSq {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-error);
  cursor: pointer;
  font-size: 3rem;
}
.Settings_cards__delete__k1TSq:hover {
  font-weight: 700;
}
.Settings_cards__delete__k1TSq p {
  font-size: 1.4rem;
  color: var(--color-deep-red);
}

.Settings_paystackButton__iRlxX {
  width: 38rem;
  border-radius: 1rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
  box-sizing: border-box;
  padding: 1.9rem 2.2rem;
  justify-content: center;
  margin-top: 2rem;
}
.Settings_paystackButton_container__789dN {
  display: flex;
  justify-content: center;
}

.Settings_subscription__fOuW4 {
  width: 42rem;
}
.Settings_subscription__planSelect__7QnZ5 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 100%;
  border-radius: 1rem;
  margin: 1rem 0;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Settings_subscription__planSelect__7QnZ5 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Settings_subscription__planSelect__active__Pq8RP {
  background-color: var(--color-primary);
  color: var(--color-white);
  transition: all 0.4s;
  border: 1px solid var(--color-primary);
  font-weight: 700;
}
.Settings_subscription__planSelect__active__1__7C6nc {
  border-radius: 1rem 0 0 1rem;
}
.Settings_subscription__planSelect__active__2__jTmek {
  border-radius: 0 1rem 1rem 0;
}
.Settings_subscription__planSelect__inactive__53kkk {
  border: 1px solid var(--color-primary);
  transition: all 0.4s;
  border: 1px solid var(--color-primary);
  color: var(--color-dark);
}
.Settings_subscription__planSelect__inactive__1__RL4vY {
  border-radius: 1rem 0 0 1rem;
}
.Settings_subscription__planSelect__inactive__2__AfVDX {
  border-radius: 0 1rem 1rem 0;
}
.Settings_subscription__planDetails__deselected__Dgcpu {
  border-radius: 1rem;
  background-color: var(--color-light);
  margin-bottom: 2rem;
  padding: 2rem;
  border: 1px solid var(--color-grey);
  cursor: pointer;
}
.Settings_subscription__planDetails__selected__2G0u4 {
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  margin-bottom: 2rem;
  padding: 2rem;
  border: 1px solid var(--color-primary-4);
  cursor: pointer;
}
.Settings_subscription__planDetails__item__4DqSY {
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 1rem;
}
.Settings_subscription__save__upfLx {
  border-radius: 1rem;
  background-color: var(--color-light-red);
  color: var(--color-error);
  font-weight: 700;
  padding: 1rem;
  border: 1px solid var(--color-error);
  font-size: var(--default-font-small);
}
.Settings_subscription__summary__gznLZ {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
.Settings_subscription__summary__item__v8OZ6 {
  background-color: var(--color-primary-3);
  padding: 1rem;
  border-radius: 1rem;
}
.Settings_subscription__img__DoUp2 {
  margin-bottom: 2rem;
  width: max-content;
}
.Settings_subscription__upgrade__rttVc {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.Settings_subscription__upgrade__item__3rFuK {
  background-color: var(--color-primary-3);
  padding: 1rem;
  border-radius: 1rem;
  height: 7.5rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
}
.Settings_subscription__upgrade__item__active__VrVXT {
  border: 2px solid var(--color-primary);
  border-radius: 1rem;
  padding: 1rem;
  transition: all 0.2s;
}

.Settings_ai__9WDvH {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  height: auto;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.Settings_ai__copy__geyfW {
  display: flex;
  font-size: 3rem;
  color: var(--color-white);
  cursor: pointer;
  background-color: var(--color-dark);
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  align-items: center;
}
.Settings_ai__card__h0SAS {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 80rem;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  gap: 1rem;
  scroll-behavior: auto;
}
@media only screen and (max-width: 43.75em) {
  .Settings_ai__card__h0SAS {
    height: auto;
    font-size: 2rem;
  }
}
.Settings_ai__card__align__RFxmd {
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  flex-wrap: wrap;
}

.Settings_imageUpload__URHrl {
  height: 10rem;
}

.Settings_beside__7hxRx {
  display: flex;
  gap: 4rem;
}

.Settings_buttonContainer__FQ223 {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 2rem;
}

.Settings_button__1ZDms {
  height: 4rem;
  width: 18rem;
  border: 1px solid #ddd;
  color: var(--color-dark);
  font-weight: normal;
  transition: background-color 0.3s, color 0.3s;
  cursor: pointer;
  text-align: center;
  line-height: 4rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Settings_button__1ZDms.Settings_active__O0LEn {
  background-color: var(--color-fash-primary-2);
  color: var(--color-white);
  font-weight: 700;
}

.Settings_button__1ZDms.Settings_dormant__Xuk2B {
  background-color: #e9ecef;
  color: var(--color-dark);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Settings/Settings.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EANF;IAOI,gBAAA;IACA,sBAAA;EAAF;AACF;AAEE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAAN;;AAOI;EADF;IAEI,aAAA;IACA,sBAAA;IACA,mBAAA;EAHJ;AACF;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,YAAA;EACA,6CAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAJN;AAMM;EACE,6CAAA;EACA,wBAAA;EACA,4CAAA;EACA,6CAAA;AAJR;AAOM;EACE,iBAAA;EACA,oBAAA;AALR;AAQM;EACE,iBAAA;EACA,yBAAA;EACA,oBAAA;AANR;;AAcI;EADF;IAEI,aAAA;IACA,sBAAA;IACA,mBAAA;EAVJ;AACF;AAYI;EACE,mBAAA;AAVN;AAaI;EACE,YAAA;EACA,mCAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AAXN;AAaM;EACE,mCAAA;EAEA,4CAAA;EACA,wCAAA;EACA,gBAAA;AAZR;AAeM;EACE,iBAAA;AAbR;;AAmBA;EACE,gBAAA;EACA,YAAA;AAhBF;AAkBE;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,kBAAA;AAhBN;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAqBI;EACE,kCAAA;AAnBN;AAwBI;EACE,mBAAA;AAtBN;AA0BE;EACE,aAAA;EACA,uBAAA;AAxBJ;AA2BE;EACE,YAAA;AAzBJ;;AA8BE;EACE,YAAA;EACA,mBAAA;AA3BJ;AA6BI;EACE,aAAA;EACA,uBAAA;AA3BN;AA+BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA7BJ;;AAkCE;EACE,aAAA;EACA,oBAAA;AA/BJ;AAiCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,wCAAA;AA/BN;AAmCE;EACE,aAAA;EACA,SAAA;AAjCJ;;AAsCE;EACE,aAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,oCAAA;AApCJ;AAsCI;EACE,mCAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;AApCN;AAsCM;EACE,6BAAA;AApCR;AAwCI;EACE,qCAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAtCN;AAwCM;EACE,6CAAA;AAtCR;;AA4CA;EACE,aAAA;EACA,SAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAzCF;AA2CE;EACE,aAAA;AAzCJ;AA4CE;EACE,gBAAA;AA1CJ;AA4CI;EACE,mBAAA;AA1CN;AA6CI;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AA3CN;AA6CM;EACE,wBAAA;EACA,sCAAA;EACA,4CAAA;AA3CR;AA8CM;EACE,wCAAA;AA5CR;AA+CM;EACE,wCAAA;AA7CR;AAgDM;EACE,wCAAA;AA9CR;AAmDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAjDJ;AAoDE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;AAlDJ;AAoDI;EACE,kBAAA;AAlDN;AAqDI;EACE,eAAA;AAnDN;AAqDM;EACE,6BAAA;AAnDR;;AAyDA;EACE,YAAA;AAtDF;AAwDE;EACE,0CAAA;EACA,cAAA;AAtDJ;;AA0DA;EACE,YAAA;AAvDF;AAyDE;EACE,iBAAA;AAvDJ;;AA2DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAxDF;AA0DE;EACE,gBAAA;EACA,kBAAA;AAxDJ;AA0DI;EACE,mBAAA;AAxDN;AA2DI;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;AAzDN;AA2DM;EACE,wBAAA;EACA,sCAAA;EACA,4CAAA;AAzDR;AA8DE;EACE,oBAAA;EACA,6CAAA;AA5DJ;AA8DI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AA5DN;AA8DM;EACE,cAAA;AA5DR;AA+DM;EACE,UAAA;EACA,kBAAA;AA7DR;AAkEE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAhEJ;;AAoEA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAjEF;;AAoEA;EACE;IACE,4BAAA;EAjEF;EAoEA;IACE,wBAAA;EAlEF;AACF;AAsEE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA;EACA,mBAAA;AApEJ;AAsEI;EACE,eAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AApEN;AAuEI;EACE,YAAA;EACA,qBAAA;AArEN;;AA0EA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAvEF;AAyEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAvEJ;;AA2EA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAxEF;AA0EE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAxEJ;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;AAzEF;AA2EE;EACE,YAAA;EACA,kBAAA;AAzEJ;AA4EE;EACE,aAAA;EACA,mBAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AA3EJ;AA6EI;EACE,gBAAA;AA3EN;AA8EI;EACE,iBAAA;EACA,4BAAA;AA5EN;;AAiFA;EACE,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA9EF;AAgFE;EACE,aAAA;EACA,uBAAA;AA9EJ;;AAkFA;EACE,YAAA;AA/EF;AAiFE;EACE,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,oCAAA;EACA,WAAA;EACA,mBAAA;EAEA,cAAA;EAEA,mBAAA;EACA,eAAA;AAjFJ;AAmFI;EACE,sBAAA;EACA,kBAAA;AAjFN;AAoFI;EACE,sCAAA;EACA,yBAAA;EACA,oBAAA;EACA,sCAAA;EACA,gBAAA;AAlFN;AAoFM;EACE,4BAAA;AAlFR;AAqFM;EACE,4BAAA;AAnFR;AAuFI;EACE,sCAAA;EACA,oBAAA;EACA,sCAAA;EACA,wBAAA;AArFN;AAuFM;EACE,4BAAA;AArFR;AAwFM;EACE,4BAAA;AAtFR;AA4FI;EACE,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;EACA,eAAA;AA1FN;AA6FI;EACE,mBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,eAAA;AA3FN;AA8FI;EACE,aAAA;EACA,sCAAA;EACA,SAAA;AA5FN;AAgGE;EACE,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,oCAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AA/FJ;AAiGI;EACE,wCAAA;EACA,aAAA;EACA,mBAAA;AA/FN;AAmGE;EACE,mBAAA;EACA,kBAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,WAAA;EACA,qCAAA;EACA,SAAA;AAlGJ;AAoGI;EACE,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAlGN;AAoGM;EACE,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAlGR;;AAwGA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,SAAA;EACA,4CAAA;AArGF;AAuGE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AArGJ;AAwGE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,SAAA;EACA,qBAAA;AAtGJ;AAwGI;EAbF;IAcI,YAAA;IACA,eAAA;EArGJ;AACF;AAuGI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,eAAA;AArGN;;AA0GA;EACE,aAAA;AAvGF;;AA0GA;EACE,aAAA;EACA,SAAA;AAvGF;;AA0GA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAvGF;;AA0GA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6CACE;EAEF,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AAzGF;;AA4GA;EACE,6CAAA;EACA,yBAAA;EACA,gBAAA;AAzGF;;AA4GA;EACE,yBAAA;EACA,wBAAA;AAzGF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.upper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n\n  @media only screen and (max-width: $bp-600) {\n    margin-top: 4rem;\n    flex-direction: column;\n  }\n\n  &__title {\n    width: 38rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &_shape {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: var(--default-font-h2);\n      font-weight: 700;\n      background-color: var(--color-fash-primary-4);\n      width: 9rem;\n      height: 9rem;\n      border-radius: 9rem;\n      margin-bottom: 2rem;\n    }\n  }\n}\n\n.main {\n  &__nav {\n    @media only screen and (max-width: $bp-600) {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n    }\n\n    &_item {\n      width: 38rem;\n      border: 1px solid var(--color-fash-primary-3);\n      border-radius: 1rem;\n      padding: 1.9rem 1rem;\n      display: grid;\n      grid-template-columns: 1fr 8fr 1fr;\n      gap: 1rem;\n      align-items: center;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        border: 2px solid var(--color-fash-primary-3);\n        color: var(--color-dark);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-fash-primary-4);\n      }\n\n      &__icon {\n        font-size: 2.5rem;\n        transition: all 0.2s;\n      }\n\n      &__icon2 {\n        font-size: 2.5rem;\n        transform: rotateZ(90deg);\n        transition: all 0.2s;\n      }\n    }\n  }\n}\n\n.sub {\n  &__nav {\n    @media only screen and (max-width: $bp-600) {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n    }\n\n    &_item {\n      width: 36rem;\n      border: 1px solid var(--color-dark);\n      border-radius: 1rem;\n      padding: 1.9rem 1rem;\n      display: grid;\n      grid-template-columns: 1fr 8fr 1fr;\n      gap: 1rem;\n      align-items: center;\n      cursor: pointer;\n      transition: all 0.2s;\n      margin-left: 2rem;\n\n      &:hover {\n        border: 2px solid var(--color-dark);\n        // color: var(--color-primary);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-light-gry);\n        font-weight: 700;\n      }\n\n      &__icon {\n        font-size: 2.5rem;\n      }\n    }\n  }\n}\n\n.bus {\n  margin-top: 1rem;\n  width: 40rem;\n\n  &__head {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    margin-bottom: 2rem;\n\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n  }\n\n  &__edit {\n    display: flex;\n    flex-direction: column;\n    font-size: 2.5rem;\n    align-items: center;\n    cursor: pointer;\n\n    & > :not(:last-child) {\n      margin-bottom: 1rem;\n    }\n\n    &:hover {\n      color: var(--color-fash-primary-3);\n    }\n  }\n\n  &__details {\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  &__img {\n    display: flex;\n    justify-content: center;\n  }\n\n  &__logo {\n    height: 7rem;\n  }\n}\n\n.sec {\n  &__img {\n    width: 25rem;\n    margin-bottom: 3rem;\n\n    &_contain {\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  &__center {\n    width: 40rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.am {\n  &__img {\n    height: 10rem;\n    border-radius: 10rem;\n\n    &_contain {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 12rem;\n      height: 12rem;\n      border-radius: 12rem;\n      background-color: var(--color-primary-7);\n    }\n  }\n\n  &__btn {\n    display: flex;\n    gap: 2rem;\n  }\n}\n\n.if {\n  &__img {\n    height: 22rem;\n  }\n\n  &__share {\n    display: flex;\n    font-size: var(--default-font-small);\n\n    &_1 {\n      background-color: var(--color-dark);\n      width: 28rem;\n      padding: 1.5rem 2rem;\n      border-radius: 2rem 0 0 2rem;\n      word-wrap: break-word;\n      color: var(--color-white);\n\n      span {\n        color: var(--color-primary-3);\n      }\n    }\n\n    &_2 {\n      background-color: var(--color-dark-3);\n      color: var(--color-white);\n      width: 10rem;\n      padding: 1.5rem 2rem;\n      border-radius: 0 2rem 2rem 0;\n      word-wrap: break-word;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-fash-primary-3);\n      }\n    }\n  }\n}\n\n.logout {\n  display: flex;\n  gap: 2rem;\n}\n\n.cs {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  &__img {\n    height: 23rem;\n  }\n\n  &__menu {\n    margin-top: 3rem;\n\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n    }\n\n    &_main {\n      display: flex;\n      padding: 2.5rem 2rem;\n      justify-content: space-between;\n      align-items: center;\n      font-size: 3rem;\n      width: 42rem;\n      border-radius: 1.5rem;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &:hover {\n        filter: brightness(1.05);\n        border: 1px solid var(--color-primary);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);\n      }\n\n      &__faq {\n        background-color: var(--color-primary-3);\n      }\n\n      &__send {\n        background-color: var(--color-primary-7);\n      }\n\n      &__speak {\n        background-color: var(--color-primary-8);\n      }\n    }\n  }\n\n  &__dials {\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    font-size: 3rem;\n    margin-bottom: 2rem;\n    cursor: pointer;\n  }\n\n  &__socials {\n    display: flex;\n    font-size: 3rem;\n    justify-content: center;\n    color: var(--color-primary);\n\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n\n    & > * {\n      cursor: pointer;\n\n      &:hover {\n        color: var(--color-primary-4);\n      }\n    }\n  }\n}\n\n.faq {\n  width: 42rem;\n\n  &__line {\n    border-top: 1px solid var(--color-primary);\n    margin: 1rem 0;\n  }\n}\n\n.pin {\n  width: 38rem;\n\n  & > :nth-child(3) {\n    margin-left: 4rem;\n  }\n}\n\n.iconfig {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  &__menu {\n    margin-top: 3rem;\n    transition: all 2s;\n\n    & > :not(:last-child) {\n      margin-bottom: 2rem;\n    }\n\n    &_main {\n      display: flex;\n      padding: 2.5rem 2rem;\n      justify-content: space-between;\n      align-items: center;\n      font-size: 3rem;\n      width: 42rem;\n      background-color: var(--color-primary-7);\n      border-radius: 1.5rem;\n      transition: all 0.2s;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(1.05);\n        border: 1px solid var(--color-primary);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.15);\n      }\n    }\n  }\n\n  &__settings {\n    padding: 2rem 1.8rem;\n    animation: translateDown 0.5s;\n\n    &_feature {\n      display: flex;\n      justify-content: space-between;\n      gap: 2rem;\n\n      &:not(:last-child) {\n        margin: 2rem 0;\n      }\n\n      &_text {\n        width: 80%;\n        align-self: center;\n      }\n    }\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n    width: 38rem;\n    flex-wrap: wrap;\n  }\n}\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n  width: 38rem;\n}\n\n@keyframes translateDown {\n  0% {\n    transform: translateY(-10px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.kyc {\n  &__list {\n    display: flex;\n    align-items: center;\n    width: 38rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid var(--color-grey);\n    margin-bottom: 2rem;\n\n    &__icon {\n      font-size: 4rem;\n      color: var(--color-green);\n      background-color: var(--color-green-3);\n      border-radius: 5rem;\n      padding: 0.5rem;\n      box-sizing: border-box;\n      margin-right: 1rem;\n    }\n\n    span {\n      width: 33rem;\n      word-wrap: break-word;\n    }\n  }\n}\n\n.bicContainer {\n  display: flex;\n  justify-content: center;\n  max-width: 36rem;\n\n  &__bic {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2rem;\n    width: 100%;\n    max-width: 36rem;\n  }\n}\n\n.configDetails {\n  display: grid;\n  grid-template-columns: 55% 35%;\n  max-width: 40rem;\n  justify-content: center;\n  justify-self: center;\n  margin-bottom: 2rem;\n  gap: 2rem;\n  padding: 0 1rem;\n\n  &_btn {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n.repeat {\n  display: flex;\n  justify-content: space-between;\n  width: 38rem;\n}\n\n.cards {\n  display: flex;\n  width: 38rem;\n  align-items: center;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--color-grey);\n  justify-content: space-between;\n\n  img {\n    height: 3rem;\n    margin-right: 3rem;\n  }\n\n  &__beside {\n    display: flex;\n    align-items: center;\n  }\n\n  &__delete {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    color: var(--color-error);\n    cursor: pointer;\n    font-size: 3rem;\n\n    &:hover {\n      font-weight: 700;\n    }\n\n    p {\n      font-size: 1.4rem;\n      color: var(--color-deep-red);\n    }\n  }\n}\n\n.paystackButton {\n  width: 38rem;\n  border-radius: 1rem;\n  background-color: var(--color-dark);\n  color: var(--color-white);\n  font-weight: 700;\n  box-sizing: border-box;\n  padding: 1.9rem 2.2rem;\n  justify-content: center;\n  margin-top: 2rem;\n\n  &_container {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.subscription {\n  width: 42rem;\n\n  &__planSelect {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    box-sizing: border-box;\n    font-size: var(--default-font-small);\n    width: 100%;\n    border-radius: 1rem;\n\n    margin: 1rem 0;\n\n    margin-bottom: 3rem;\n    cursor: pointer;\n\n    & > * {\n      padding: 1rem 0 1rem 0;\n      text-align: center;\n    }\n\n    &__active {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n      transition: all 0.4s;\n      border: 1px solid var(--color-primary);\n      font-weight: 700;\n\n      &__1 {\n        border-radius: 1rem 0 0 1rem;\n      }\n\n      &__2 {\n        border-radius: 0 1rem 1rem 0;\n      }\n    }\n\n    &__inactive {\n      border: 1px solid var(--color-primary);\n      transition: all 0.4s;\n      border: 1px solid var(--color-primary);\n      color: var(--color-dark);\n\n      &__1 {\n        border-radius: 1rem 0 0 1rem;\n      }\n\n      &__2 {\n        border-radius: 0 1rem 1rem 0;\n      }\n    }\n  }\n\n  &__planDetails {\n    &__deselected {\n      border-radius: 1rem;\n      background-color: var(--color-light);\n      margin-bottom: 2rem;\n      padding: 2rem;\n      border: 1px solid var(--color-grey);\n      cursor: pointer;\n    }\n\n    &__selected {\n      border-radius: 1rem;\n      background-color: var(--color-primary-3);\n      margin-bottom: 2rem;\n      padding: 2rem;\n      border: 1px solid var(--color-primary-4);\n      cursor: pointer;\n    }\n\n    &__item {\n      display: grid;\n      grid-template-columns: min-content 1fr;\n      gap: 1rem;\n    }\n  }\n\n  &__save {\n    border-radius: 1rem;\n    background-color: var(--color-light-red);\n    color: var(--color-error);\n    font-weight: 700;\n    padding: 1rem;\n    border: 1px solid var(--color-error);\n    font-size: var(--default-font-small);\n  }\n\n  &__summary {\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n\n    &__item {\n      background-color: var(--color-primary-3);\n      padding: 1rem;\n      border-radius: 1rem;\n    }\n  }\n\n  &__img {\n    margin-bottom: 2rem;\n    width: max-content;\n  }\n\n  &__upgrade {\n    display: grid;\n    width: 100%;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2rem;\n\n    &__item {\n      background-color: var(--color-primary-3);\n      padding: 1rem;\n      border-radius: 1rem;\n      height: 7.5rem;\n      font-weight: 700;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n      transition: all 0.2s;\n\n      &__active {\n        border: 2px solid var(--color-primary);\n        border-radius: 1rem;\n        padding: 1rem;\n        transition: all 0.2s;\n      }\n    }\n  }\n}\n\n.ai {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  padding: 3rem 5rem 3rem 5rem;\n  border-radius: 1rem;\n  background-color: var(--color-white);\n  height: auto;\n  gap: 2rem;\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n  &__copy {\n    display: flex;\n    font-size: 3rem;\n    color: var(--color-white);\n    cursor: pointer;\n    background-color: var(--color-dark);\n    padding: 1rem 2rem;\n    border-radius: 0.5rem;\n    align-items: center;\n  }\n\n  &__card {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    min-width: 80rem;\n    flex-wrap: wrap;\n    box-sizing: border-box;\n    padding: 2rem;\n    border-radius: 1rem;\n    background-color: var(--color-primary-3);\n    gap: 1rem;\n    scroll-behavior: auto;\n\n    @media only screen and (max-width: $bp-700) {\n      height: auto;\n      font-size: 2rem;\n    }\n\n    &__align {\n      display: flex;\n      justify-content: space-between;\n      max-width: 100%;\n      flex-wrap: wrap;\n    }\n  }\n}\n\n.imageUpload {\n  height: 10rem;\n}\n\n.beside {\n  display: flex;\n  gap: 4rem;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: space-between;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.button {\n  height: 4rem;\n  width: 18rem;\n  border: 1px solid #ddd;\n  color: var(--color-dark);\n  font-weight: normal;\n  transition:\n    background-color 0.3s,\n    color 0.3s;\n  cursor: pointer;\n  text-align: center;\n  line-height: 4rem;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.button.active {\n  background-color: var(--color-fash-primary-2);\n  color: var(--color-white);\n  font-weight: 700;\n}\n\n.button.dormant {\n  background-color: #e9ecef;\n  color: var(--color-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Settings_upper__VkmmB`,
	"upper__title": `Settings_upper__title__k8wwl`,
	"upper__title_shape": `Settings_upper__title_shape__X3-hw`,
	"main__nav": `Settings_main__nav__7J4Il`,
	"main__nav_item": `Settings_main__nav_item__XO2S4`,
	"main__nav_item__icon": `Settings_main__nav_item__icon__Qs5-6`,
	"main__nav_item__icon2": `Settings_main__nav_item__icon2__mFi3W`,
	"sub__nav": `Settings_sub__nav__HWTrS`,
	"sub__nav_item": `Settings_sub__nav_item__OCNaP`,
	"sub__nav_item__icon": `Settings_sub__nav_item__icon__aS4MS`,
	"bus": `Settings_bus__FfqYA`,
	"bus__head": `Settings_bus__head__+iwa1`,
	"bus__edit": `Settings_bus__edit__u-pM8`,
	"bus__details": `Settings_bus__details__UXQRr`,
	"bus__img": `Settings_bus__img__H3nvL`,
	"bus__logo": `Settings_bus__logo__cbPcH`,
	"sec__img": `Settings_sec__img__UBa8n`,
	"sec__img_contain": `Settings_sec__img_contain__pg1nC`,
	"sec__center": `Settings_sec__center__TahHv`,
	"am__img": `Settings_am__img__1DqEQ`,
	"am__img_contain": `Settings_am__img_contain__-SJHU`,
	"am__btn": `Settings_am__btn__9MQlO`,
	"if__img": `Settings_if__img__3br2T`,
	"if__share": `Settings_if__share__BsmS-`,
	"if__share_1": `Settings_if__share_1__obhQz`,
	"if__share_2": `Settings_if__share_2__zcvCB`,
	"logout": `Settings_logout__U3JnU`,
	"cs": `Settings_cs__gIIaj`,
	"cs__img": `Settings_cs__img__r1mT5`,
	"cs__menu": `Settings_cs__menu__RE8EV`,
	"cs__menu_main": `Settings_cs__menu_main__3YUqa`,
	"cs__menu_main__faq": `Settings_cs__menu_main__faq__nSrYx`,
	"cs__menu_main__send": `Settings_cs__menu_main__send__OP8TA`,
	"cs__menu_main__speak": `Settings_cs__menu_main__speak__a8FDJ`,
	"cs__dials": `Settings_cs__dials__mCgL-`,
	"cs__socials": `Settings_cs__socials__eF8CK`,
	"faq": `Settings_faq__eYSCI`,
	"faq__line": `Settings_faq__line__acoxP`,
	"pin": `Settings_pin__4qjSC`,
	"iconfig": `Settings_iconfig__CVqHf`,
	"iconfig__menu": `Settings_iconfig__menu__JlARv`,
	"iconfig__menu_main": `Settings_iconfig__menu_main__F5odO`,
	"iconfig__settings": `Settings_iconfig__settings__knJP-`,
	"translateDown": `Settings_translateDown__EEHVR`,
	"iconfig__settings_feature": `Settings_iconfig__settings_feature__fi1QQ`,
	"iconfig__settings_feature_text": `Settings_iconfig__settings_feature_text__YiTrx`,
	"iconfig__beside": `Settings_iconfig__beside__Rov1s`,
	"error": `Settings_error__B+Z6D`,
	"kyc__list": `Settings_kyc__list__OkdXD`,
	"kyc__list__icon": `Settings_kyc__list__icon__7d40V`,
	"bicContainer": `Settings_bicContainer__Jo9Bc`,
	"bicContainer__bic": `Settings_bicContainer__bic__EYiXy`,
	"configDetails": `Settings_configDetails__f4LiO`,
	"configDetails_btn": `Settings_configDetails_btn__w9tUy`,
	"repeat": `Settings_repeat__0X8Xw`,
	"cards": `Settings_cards__FXfy5`,
	"cards__beside": `Settings_cards__beside__2Z3Xb`,
	"cards__delete": `Settings_cards__delete__k1TSq`,
	"paystackButton": `Settings_paystackButton__iRlxX`,
	"paystackButton_container": `Settings_paystackButton_container__789dN`,
	"subscription": `Settings_subscription__fOuW4`,
	"subscription__planSelect": `Settings_subscription__planSelect__7QnZ5`,
	"subscription__planSelect__active": `Settings_subscription__planSelect__active__Pq8RP`,
	"subscription__planSelect__active__1": `Settings_subscription__planSelect__active__1__7C6nc`,
	"subscription__planSelect__active__2": `Settings_subscription__planSelect__active__2__jTmek`,
	"subscription__planSelect__inactive": `Settings_subscription__planSelect__inactive__53kkk`,
	"subscription__planSelect__inactive__1": `Settings_subscription__planSelect__inactive__1__RL4vY`,
	"subscription__planSelect__inactive__2": `Settings_subscription__planSelect__inactive__2__AfVDX`,
	"subscription__planDetails__deselected": `Settings_subscription__planDetails__deselected__Dgcpu`,
	"subscription__planDetails__selected": `Settings_subscription__planDetails__selected__2G0u4`,
	"subscription__planDetails__item": `Settings_subscription__planDetails__item__4DqSY`,
	"subscription__save": `Settings_subscription__save__upfLx`,
	"subscription__summary": `Settings_subscription__summary__gznLZ`,
	"subscription__summary__item": `Settings_subscription__summary__item__v8OZ6`,
	"subscription__img": `Settings_subscription__img__DoUp2`,
	"subscription__upgrade": `Settings_subscription__upgrade__rttVc`,
	"subscription__upgrade__item": `Settings_subscription__upgrade__item__3rFuK`,
	"subscription__upgrade__item__active": `Settings_subscription__upgrade__item__active__VrVXT`,
	"ai": `Settings_ai__9WDvH`,
	"ai__copy": `Settings_ai__copy__geyfW`,
	"ai__card": `Settings_ai__card__h0SAS`,
	"ai__card__align": `Settings_ai__card__align__RFxmd`,
	"imageUpload": `Settings_imageUpload__URHrl`,
	"beside": `Settings_beside__7hxRx`,
	"buttonContainer": `Settings_buttonContainer__FQ223`,
	"button": `Settings_button__1ZDms`,
	"active": `Settings_active__O0LEn`,
	"dormant": `Settings_dormant__Xuk2B`
};
export default ___CSS_LOADER_EXPORT___;
